export default function reducer(
  state = {
    status: "",
    error: null,
    summons_new: 0,
    summons_today: 0,
    issued: {
      loaded: false,
      error: null,
      data: {
        byid: {},
        list: [],
      },
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      },
      typeahead: {
        staffId: [],
        name: [],
        device: [],
        omatric: [],
        oname: [],
        refnum: [],
        regnum: []
      }
    },
    verified: {
      loaded: false,
      error: null,
      data: {
        byid: {},
        list: [],
      },
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      },
      typeahead: {
        staffId: [],
        name: [],
        device: [],
        omatric: [],
        oname: [],
        refnum: [],
        regnum: []
      }
    },
    rejected: {
      loaded: false,
      error: null,
      data: {
        byid: {},
        list: [],
      },
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      },
      typeahead: {
        staffId: [],
        name: [],
        device: [],
        omatric: [],
        oname: [],
        refnum: [],
        regnum: []
      }
    },
    billed: {
      loaded: false,
      error: null,
      data: {
        byid: {},
        list: [],
      },
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      },
      typeahead: {
        staffId: [],
        name: [],
        device: [],
        omatric: [],
        oname: [],
        refnum: [],
        regnum: []
      }
    },
    detail: {
      loaded: false,
      data: null,
      error: null
    }
  },
  action
) {
  let data
  switch (action.type) {
    case "CLEAR_STORE":
      state = defaultState()
      break;
    case "SUMMONS_STATISTICS_COUNT":
      data = action.payload.data
      state = {
        ...state,
        error: null,
        status: "SUMMONS_STATISTICS_COUNT",
        summons_new: data.summons_new,
        summons_today: data.summons_today
      }
      break;
    case "SUMMONS_STATISTICS_FULFILLED":
      data = action.payload.data
      state = {
        ...state,
        error: null,
        status: "SUMMONS_STATISTICS_FULFILLED",
        summons_new: data.new,
        summons_today: data.today
      }
      break;

    case "SUMMONS_ISSUED_ITEMPERPAGE":
      state = onIssuedItemPerPage(state, action.payload.count)
      break;
    case "SUMMONS_ISSUED_CURRENTPAGE":
      state = onIssuedCurrentPage(state, action.payload.page)
      break;
    case "SUMMONS_ISSUED_GET_FULFILLED":
      state = onIssuedFulfilled(state, action.payload.data)
      break;
    case "SUMMONS_ISSUED_GET_REJECTED":
      state = onIssuedRejected(state, action.payload.error)
      break;
    case "SUMMONS_ISSUED_CLEAR":
      state = {
        ...state,
        issued: {
          ...state.issued,
          data: {
            byid: {},
            list: [],
          },
          pagination: {
            count: 0,
            total: 0,
            currentPage: 1,
            itemPerPage: state.issued.pagination.itemPerPage,
            pageCount: 1
          },
          typeahead: { ...state.issued.typeahead }
          }
        }
        break;
        case "SUMMONS_ISSSUED_TYPEAHEAD_FULFILLED":
          state = onIssuedTypeahed(state, action.payload.data)
          break;
    case "SUMMONS_APPROVED_ITEMPERPAGE":
      state = onChangeApprovedItemPerPage(state, action.payload)
      break;
    case "SUMMONS_APPROVED_CURRPAGE":
      state = onChangeApprovedCurrentPage(state, action.payload)
      break;
    case "SUMMONS_APPROVED_GET_FULFILLED":
      state = onApprovedFulfilled(state, action.payload.data)
      break;
    case "SUMMONS_APPROVED_CLEAR":
      state = {
        ...state,
        verified: {
          ...state.verified,
          data: {
            byid: {},
            list: [],
          },
          pagination: {
            count: 0,
            total: 0,
            currentPage: 1,
            itemPerPage: state.verified.pagination.itemPerPage,
            pageCount: 1
          },
          typeahead: { ...state.verified.typeahead }
        }
      }
      break;
      case "SUMMONS_APPROVED_TYPEAHEAD_FULFILLED":
        state = onApprovedTypeahed(state, action.payload.data)
        break;
    case "SUMMONS_APPROVED_GET_REJECTED":
      state = onApprovedRejected(state, action.payload.error)
      break;

    case "SUMMONS_ARCHIVED_ITEMPERPAGE":
      state = onChangeArchivedItemPerPage(state, action.payload)
      break;
    case "SUMMONS_ARCHIVED_CURRPAGE":
      state = onChangeArchivedCurrentPage(state, action.payload)
      break;
    case "SUMMONS_ARCHIVED_GET_FULFILLED":
      state = onArchivedFulfilled(state, action.payload.data)
      break;
    case "SUMMONS_ARCHIVED_CLEAR":
      state = {
        ...state,
        rejected: {
          ...state.rejected,
          data: {
            byid: {},
            list: [],
          },
          pagination: {
            count: 0,
            total: 0,
            currentPage: 1,
            itemPerPage: state.rejected.pagination.itemPerPage,
            pageCount: 1
          },
          typeahead: { ...state.rejected.typeahead }
        }
      }
      break;
    case "SUMMONS_ARCHIVED_GET_REJECTED":
      state = onArchivedRejected(state, action.payload.error)
      break;

    case "SUMMONS_GET_BYID_CLEAR":
      state = {
        ...state,
        detail: {
          loaded: false,
          data: null,
          error: null
        }
      }
      break;
    case "SUMMONS_GET_BYID_FULFILLED":
      state = {
        ...state,
        detail: action.payload
      }
      break;
    case "SUMMONS_GET_BYID_REJECTED":
      state = {
        ...state,
        detail: action.payload
      }
      break;
    case "SUMMONS_DETAIL_MODIFY_FINE":
      state = onDetailModifyFine(state, action.payload.id, action.payload.val)
      break;
    default:
      return state;
  }
  return state;
}

function defaultState() {
  return {
    status: "",
    error: null,
    summons_new: 0,
    summons_today: 0,
    issued: {
      loaded: false,
      error: null,
      data: {
        byid: {},
        list: [],
        error: null
      },
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      },
      typeahead: {
        staffId: [],
        name: [],
        device: [],
        omatric: [],
        oname: [],
        refnum: [],
        regnum: []
      }
    },
    verified: {
      loaded: false,
      error: null,
      data: {
        byid: {},
        list: [],
      },
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      },
      typeahead: {
        staffId: [],
        name: [],
        device: [],
        omatric: [],
        oname: [],
        refnum: [],
        regnum: []
      }
    },
    rejected: {
      loaded: false,
      error: null,
      data: {
        byid: {},
        list: [],
      },
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      },
      typeahead: {
        staffId: [],
        name: [],
        device: [],
        omatric: [],
        oname: [],
        refnum: [],
        regnum: []
      }
    },
    billed: {
      loaded: false,
      error: null,
      data: {
        byid: {},
        list: [],
      },
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1
      },
      typeahead: {
        staffId: [],
        name: [],
        device: [],
        omatric: [],
        oname: [],
        refnum: [],
        regnum: []
      }
    },
    detail: {
      loaded: false,
      data: null,
      error: null
    }
  }
}

//==================================================================
function onDetailModifyFine(state, id, val) {
  let { detail, ..._state } = state
  let { data, ..._detail } = detail

  let _data = {
    ...data,
    fine: val
  };

  _detail = {
    ..._detail,
    data: _data
  }
  _state = {
    ..._state,
    detail: _detail
  }
  return _state
}

function onIssuedItemPerPage(state, count) {
  let { issued, ..._state } = state
  let { pagination, ..._issued } = issued
  let _pagination = {
    ...pagination,
    itemPerPage: count,
    pageCount: Math.ceil(pagination.total / count),
    currentPage: 1
  }

  _issued = {
    ..._issued,
    pagination: _pagination
  }
  _state = {
    ..._state,
    issued: _issued
  }
  return _state
}
function onIssuedCurrentPage(state, page) {
  let { issued, ..._state } = state
  let { pagination, ..._issued } = issued
  let _pagination = {
    ...pagination,
    currentPage: page
  }

  _issued = {
    ..._issued,
    pagination: _pagination
  }
  _state = {
    ..._state,
    issued: _issued
  }
  return _state
}
function onIssuedFulfilled(state, i) {
  // console.log("debug: onIssuedFulfilled : \n", i);
  i = onSummonNormalized(i)
  // console.log("debug: onIssuedFulfilled.normalized : \n", i);

  let { issued, ..._state } = state
  let { data, pagination, ..._issued } = issued

  let _pageCount = Math.ceil(i.total / pagination.itemPerPage)
  if (_pageCount < 1) {
    _pageCount = 1
  }
  let _currentPage = pagination.currentPage
  if (pagination.currentPage > _pageCount) {
    _currentPage = _pageCount
  }

  let _pagination = {
    ...pagination,
    count: i.count,
    total: i.total,
    currentPage: _currentPage,
    pageCount: _pageCount
  }

  let { byid, list, ..._data } = data
  let _byid = { ...byid, ...i.summons.byid }

  let _list = [...list]
  if (pagination.total !== _pagination.total) {
    _list = new Array(i.total).fill(-1)
  }
  if (_pagination.total < 1) {
    _list = []
  } else {
    _list.splice(i.skip, i.summons.list.length, ...i.summons.list)
  }

  _data = { ..._data, byid: _byid, list: _list }
  _issued = { ..._issued, data: _data, pagination: _pagination, loaded: true, error: null }
  _state = { ..._state, issued: _issued }

  return _state
}
function onIssuedRejected(state, e) {
  state = {
    ...state,
    issued: {
      ...state.issued,
      loaded: true,
      error: e
    }
  }
  return state
}

function onChangeApprovedItemPerPage(state, val) {
  let { verified, ..._state } = state
  let { pagination, ..._verified } = verified
  let _pagination = {
    ...pagination,
    itemPerPage: val
  }
  _verified = {
    ..._verified,
    pagination: _pagination
  }
  _state = {
    ..._state,
    verified: _verified
  }
  return _state
}
function onChangeApprovedCurrentPage(state, val) {
  let { verified, ..._state } = state
  let { pagination, ..._verified } = verified
  let _pagination = {
    ...pagination,
    currentPage: val
  }
  _verified = {
    ..._verified,
    pagination: _pagination
  }
  _state = {
    ..._state,
    verified: _verified
  }
  return _state
}
function onApprovedFulfilled(state, i) {
  i = onSummonNormalized(i)
  let { verified, ..._state } = state
  let { data, pagination, ..._verified } = verified

  let _pageCount = Math.ceil(i.total / pagination.itemPerPage)
  if (_pageCount < 1) {
    _pageCount = 1
  }
  let _currentPage = pagination.currentPage
  if (pagination.currentPage > _pageCount) {
    _currentPage = _pageCount
  }

  let _pagination = {
    ...pagination,
    count: i.count,
    total: i.total,
    currentPage: _currentPage,
    pageCount: _pageCount
  }

  let { byid, list, ..._data } = data
  let _byid = { ...byid, ...i.summons.byid }

  let _list = [...list]
  if (pagination.total !== _pagination.total) {
    _list = new Array(i.total).fill(-1)
  }
  if (_pagination.total < 1) {
    _list = []
  } else {
    _list.splice(i.skip, i.summons.list.length, ...i.summons.list)
  }

  _data = { ..._data, byid: _byid, list: _list }
  _verified = { ..._verified, data: _data, pagination: _pagination, loaded: true, error: null }
  _state = { ..._state, verified: _verified }

  return _state;
}
function onApprovedRejected(state, e) {
  state = {
    ...state,
    verified: {
      ...state.verified,
      loaded: true,
      error: e
    }
  }
  return state
}

function onIssuedTypeahed(state, opts) {
  //console.log("onIssuedTypeahed :", opts)
  let { issued, ..._state } = state;
  // eslint-disable-next-line no-unused-vars
  let { typeahead, ..._issued } = issued
  var _typeahead = { ...opts };

  _issued = { ..._issued, typeahead: _typeahead }
  _state = { ..._state, issued: _issued }

  return _state;
}
function onApprovedTypeahed(state, opts) {
  //console.log("onIssuedTypeahed :", opts)
  let { verified, ..._state } = state;
  // eslint-disable-next-line no-unused-vars
  let { typeahead, ..._verified } = verified
  var _typeahead = { ...opts };

  _verified = { ..._verified, typeahead: _typeahead }
  _state = { ..._state, verified: _verified }

  return _state;
}

function onChangeArchivedItemPerPage(state, val) {
  let { rejected, ..._state } = state
  let { pagination, ..._rejected } = rejected
  let _pagination = {
    ...pagination,
    itemPerPage: val
  }
  _rejected = {
    ..._rejected,
    pagination: _pagination
  }
  _state = {
    ..._state,
    rejected: _rejected
  }
  return _state
}
function onChangeArchivedCurrentPage(state, val) {
  let { rejected, ..._state } = state
  let { pagination, ..._rejected } = rejected
  let _pagination = {
    ...pagination,
    currentPage: val
  }
  _rejected = {
    ..._rejected,
    pagination: _pagination
  }
  _state = {
    ..._state,
    rejected: _rejected
  }
  return _state
}
function onArchivedFulfilled(state, i) {
  i = onSummonNormalized(i)
  let { rejected, ..._state } = state
  let { data, pagination, ..._rejected } = rejected

  let _pageCount = Math.ceil(i.total / pagination.itemPerPage)
  if (_pageCount < 1) {
    _pageCount = 1
  }
  let _currentPage = pagination.currentPage
  if (pagination.currentPage > _pageCount) {
    _currentPage = _pageCount
  }

  let _pagination = {
    ...pagination,
    count: i.count,
    total: i.total,
    currentPage: _currentPage,
    pageCount: _pageCount
  }

  let { byid, list, ..._data } = data
  let _byid = { ...byid, ...i.summons.byid }

  let _list = [...list]
  if (pagination.total !== _pagination.total) {
    _list = new Array(i.total).fill(-1)
  }
  if (_pagination.total < 1) {
    _list = []
  } else {
    _list.splice(i.skip, i.summons.list.length, ...i.summons.list)
  }

  _data = { ..._data, byid: _byid, list: _list }
  _rejected = { ..._rejected, data: _data, pagination: _pagination, loaded: true, error: null }
  _state = { ..._state, rejected: _rejected }

  return _state;
}
function onArchivedRejected(state, e) {
  state = {
    ...state,
    rejected: {
      ...state.rejected,
      loaded: true,
      error: e
    }
  }
  return state;
}

function onSummonNormalized(issued) {
  // console.log("debug: onIssuedNormalized > issued :\n", issued);
  let { summons, ..._issued } = issued
  let _summons = {
    byid: {},
    list: []
  }
  let count = 1;
  summons.forEach(r => {
    // console.log("debug: onIssuedNormalized > issued.ref :\n", r.ref);
    if (!_summons.byid[r.ref]) {
      _summons.list.push(r.ref);
      _summons.byid[r.ref] = r;
    }else{
      _summons.list.push(r.ref+`-${count}`);
      _summons.byid[r.ref+`-${count}`] = r;
      count++;
    }
  })
  _issued = { ..._issued, summons: { ..._summons } }
  return _issued
}



// WEBPACK FOOTER //
// ./src/redux/reducers/_summons.js